// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/frames.scss
// module id = 1
// module chunks = 0